import { bool } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { usePresetFieldNames, useEstimateEditorSettings, ValueCell } from "@tools";

export const CompanyCostCell = observer((cellProps) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_COST }
      useDynamicWidth
      isHeader
      style={{ cursor: allowEdition && "grab" }}
      { ...cellProps }
    >
      <span>
        { getFieldName("pt-paCost") }
      </span>
    </ValueCell>
  )
})

CompanyCostCell.propTypes = {
  extendPadding: bool,
}